<template>
  <div>
    <v-dialog v-model="openDialog" max-width="1200px" persistent scrollable>
      <template v-slot:activator="{ on }">
        <mf-button label="Selecionar campanhas" @click="openDialog = true" />
      </template>
      <v-card>
        <v-card-title>
          <span class="mf-h6 primary-text">Selecionar campanhas</span>
        </v-card-title>
        <v-card-text>
          <select-benefits-table v-model="selectedCampaigns" :status="status" />
        </v-card-text>
        <v-card-actions class="d-flex justify-end">
          <mf-action-buttons
            class="mt-2"
            :primary-button="{
              text: 'Confirmar',
              action: save,
              isVisible: true,
            }"
            :extra-button="{
              text: 'Cancelar',
              action: closeDialog,
              isVisible: true,
            }"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-chip-group v-if="loadingInitialState" column active-class="primary--text">
      <v-chip v-for="(campaign, index) in initialValue" :key="`${index}-loading`" class="disabled-chip" small :ripple="false">
        <v-progress-circular indeterminate color="primary" size="15" />
      </v-chip>
    </v-chip-group>

    <v-chip-group column active-class="primary--text">
      <v-chip
        v-for="(campaign, index) in selectedCampaigns"
        :key="`chip-${index}-loaded`"
        class="disabled-chip"
        small
        :close="!disabled"
        :ripple="false"
        @click:close="removeSelectedCampaign(index)"
      >
        <span>{{ campaign.title }}</span>
      </v-chip>
    </v-chip-group>
  </div>
</template>

<script>
import SelectBenefitsTable from '@/modules/campanhas/cupom-desconto/views/components/segmentation/SelectBenefitsTable.vue'
import { QUERY_FIND_BENEFITS } from '@/modules/campanhas/cupom-desconto/graphql'

export default {
  components: { SelectBenefitsTable },
  props: {
    status: {
      type: Array,
      default: () => ['ACTIVE', 'FINISHED'],
    },
    initialValue: {
      type: [Array, Number],
      default: () => {
        return []
      },
    },
    currentIndex: Number,
    values: {
      type: [Array, Number],
      default: () => {
        return []
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      openDialog: false,
      selectedCampaigns: [],
      loadingInitialState: false,
    }
  },
  computed: {
    query() {
      return QUERY_FIND_BENEFITS
    },
  },
  async mounted() {
    await this.setInitialState()
    this.validate()
  },
  methods: {
    validate() {
      this.$emit('validate', { isValid: this.isValid(), currentIndex: this.currentIndex })
    },
    isValid() {
      return Boolean(this.selectedCampaigns && this.selectedCampaigns.length)
    },
    async setInitialState() {
      if (this.initialValue && this.initialValue.length > 0) {
        await this.getCampaigns(this.initialValue)
      } else {
        this.selectedCampaigns = []
      }
    },
    closeDialog() {
      this.openDialog = false
    },
    save() {
      this.$emit('input', { currentValue: this.selectedCampaigns.map(({ _id }) => _id), currentChildren: this.values[0], currentIndex: this.currentIndex })
      this.validate()
      this.closeDialog()
    },
    removeSelectedCampaign(index) {
      this.selectedCampaigns.splice(index, 1)
    },
    async getCampaigns(campaignIds) {
      const queryVariables = {
        input: {
          ids: campaignIds,
          status: this.status.map((status) => status.toUpperCase()),
          page: 0,
          pageSize: campaignIds.length,
        },
      }
      try {
        this.loadingInitialState = true
        const variables = { ...queryVariables }
        const { data } = await this.$apollo.query({
          query: this.query,
          variables,
          fetchPolicy: 'no-cache',
          context: {
            uri: this.$microservicesUrls['benefitsManager'],
          },
        })
        this.selectedCampaigns = data.findPaginatedBenefits.benefits
      } catch (error) {
        this.$snackbar({ message: 'Erro ao buscar dados no servidor', snackbarColor: 'error' })
      }
      this.loadingInitialState = false
    },
  },
}
</script>
